<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <convfact-bail-form [bail]="bail" [concepts]="concepts" [errors]="errors" [accountsAndTaxes]="accountsAndTaxes"
    [bankAccounts]="bankAccounts" [paymentCards]="paymentCards" (onSave)="saveData($event)"></convfact-bail-form>
</ng-container>